import { render, staticRenderFns } from "./uploadTemp.vue?vue&type=template&id=0c45714a&"
import script from "./uploadTemp.vue?vue&type=script&lang=js&"
export * from "./uploadTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports